import assetXHugoLogo from './x-hugo-logo.svg';
enum LogoName {
  Hugo = 'Hugo',
}

export const filterLogoAssets: {[key in LogoName]: string} = {
  [LogoName.Hugo]: assetXHugoLogo,
};
